import { endpointConfig } from "../../../config/api-config";

export const buildShiftUpdateRequest = (topicId, data) => ({
  endpoint: endpointConfig.shift_by_id(topicId),
  data
});

export const buildShiftStartTimeUpdateRequest = (topicId, execStartTime) => ({
  ...buildShiftUpdateRequest(topicId, {
    execStartTime
  })
});
